import matches from 'matches-selector';

export function parentsUntil(element, until, selector) {
  let parent = element.parentNode;
  let parents = [];

  while (parent && parent !== document) {
    if (selector == null || matches(parent, selector)) {
      parents.push(parent);
    }
    if (matches(parent, until)) break;
    parent = parent.parentNode;
  }
  return parents;
}
